import { isEmpty } from 'lodash-es';

import { DEFAULT_UNITY_BLOCK } from '@@editor/constants';

const makeDefaultTextIfNull = (value) => (isEmpty(value) ? DEFAULT_UNITY_BLOCK : value);

export default makeDefaultTextIfNull;
